import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["state", "onRowSelectionChange", "onColumnFiltersChange", "onPaginationChange", "onSearchChange"],
  _excluded2 = ["rowSelection", "search"],
  _excluded3 = ["setRowSelection", "getIsAllRowsSelected", "getIsSomePageRowsSelected", "getSelectedRowModel", "toggleAllPageRowsSelected"];
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
export * from '@tanstack/react-table';
export var useTable = function useTable(_ref) {
  var state = _ref.state,
    onRowSelectionChange = _ref.onRowSelectionChange,
    _onColumnFiltersChange = _ref.onColumnFiltersChange,
    onPaginationChange = _ref.onPaginationChange,
    onSearchChange = _ref.onSearchChange,
    options = _objectWithoutProperties(_ref, _excluded);
  var rowSelection = state.rowSelection,
    search = state.search,
    tanstackState = _objectWithoutProperties(state, _excluded2);
  var isRowSelectionDisabled = !rowSelection || !onRowSelectionChange;
  var _useReactTable = useReactTable(_objectSpread(_objectSpread({
      manualPagination: true,
      manualSorting: true,
      manualFiltering: true,
      getRowId: function getRowId(row) {
        return row.id;
      },
      getCoreRowModel: getCoreRowModel(),
      onPaginationChange: onPaginationChange,
      onColumnFiltersChange: function onColumnFiltersChange(filters) {
        // biome-ignore lint/style/useBlockStatements: single-line early return
        if (!_onColumnFiltersChange) return;

        // biome-ignore lint/style/useBlockStatements: single-line early return
        if (onRowSelectionChange && rowSelection !== null && rowSelection !== void 0 && rowSelection.isSelectAllActive) onRowSelectionChange({
          selectedRows: new Set(),
          isSelectAllActive: false,
          showSelection: false
        });
        onPaginationChange(_objectSpread(_objectSpread({}, state.pagination), {}, {
          pageIndex: 0
        }));
        _onColumnFiltersChange(filters);
      }
    }, tanstackState), options)),
    setRowSelection = _useReactTable.setRowSelection,
    getIsAllRowsSelected = _useReactTable.getIsAllRowsSelected,
    getIsSomePageRowsSelected = _useReactTable.getIsSomePageRowsSelected,
    getSelectedRowModel = _useReactTable.getSelectedRowModel,
    toggleAllPageRowsSelected = _useReactTable.toggleAllPageRowsSelected,
    table = _objectWithoutProperties(_useReactTable, _excluded3);
  var handleSelectionChange = function handleSelectionChange(values) {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (isRowSelectionDisabled) return;
    onRowSelectionChange(_objectSpread(_objectSpread({}, rowSelection), {}, {
      showSelection: true
    }, values));
  };
  var clearRowSelection = function clearRowSelection() {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (isRowSelectionDisabled) return;
    onRowSelectionChange({
      selectedRows: new Set(),
      isSelectAllActive: false,
      showSelection: false
    });
  };
  var togglePageSelection = function togglePageSelection(value) {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (isRowSelectionDisabled) return;

    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (rowSelection.isSelectAllActive) return clearRowSelection();
    var selectedRows = new Set(rowSelection.selectedRows);
    value ? options.data.forEach(function (item) {
      return selectedRows.add(item.id);
    }) : options.data.forEach(function (item) {
      return selectedRows["delete"](item.id);
    });
    onRowSelectionChange({
      selectedRows: selectedRows,
      isSelectAllActive: false,
      showSelection: true
    });
  };
  var setRowSelectionValue = function setRowSelectionValue(value, id) {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (isRowSelectionDisabled) return;

    // If select all is active, we only select the current page but the row from the selection
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (rowSelection.isSelectAllActive) return onRowSelectionChange({
      selectedRows: new Set(options.data.filter(function (item) {
        return item.id !== id;
      }).map(function (item) {
        return item.id;
      })),
      isSelectAllActive: false,
      showSelection: true
    });
    var selectedRows = new Set(rowSelection.selectedRows);
    value ? selectedRows.add(id) : selectedRows["delete"](id);
    onRowSelectionChange({
      isSelectAllActive: false,
      showSelection: true,
      selectedRows: selectedRows
    });
  };
  var isSomeRowSelectedInCurrentPage = rowSelection ? options.data.some(function (item) {
    return rowSelection.selectedRows.has(item.id);
  }) : false;
  var selectAllRows = function selectAllRows() {
    return handleSelectionChange({
      isSelectAllActive: true
    });
  };
  var searchRows = function searchRows(searchValue) {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (!onSearchChange) return;

    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (rowSelection !== null && rowSelection !== void 0 && rowSelection.isSelectAllActive) clearRowSelection();
    onSearchChange(searchValue);
    onPaginationChange(_objectSpread(_objectSpread({}, state.pagination), {}, {
      pageIndex: 0
    }));
  };
  return _objectSpread(_objectSpread({}, table), {}, {
    searchState: search,
    rowSelectionState: rowSelection,
    isSomeRowSelectedInCurrentPage: isSomeRowSelectedInCurrentPage,
    pageSize: state.pagination.pageSize,
    currentPage: state.pagination.pageIndex,
    clearRowSelection: clearRowSelection,
    togglePageSelection: togglePageSelection,
    setRowSelectionValue: setRowSelectionValue,
    selectAllRows: selectAllRows,
    searchRows: searchRows
  });
};